import React from "react";
import PropTypes from "prop-types";

import globalStyles from "../../../../globalStyles";
import { ProjectCard, Section } from "../../../../components";
import { projects } from "../../data";
import { useWindowSize } from "../../../../hooks";
import { K_MOBILE_SIZE } from "../../../../constants";

const ProjectsSection = (props) => {
  const { anchorRef } = props;
  const { width } = useWindowSize();

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };
  return (
    <Section style={styles.section} anchorRef={anchorRef}>
      <h1 style={styles.title}>PROJECTS</h1>

      <div style={styles.projectCardContainer}>
        {projects.filter(project => project.onDisplay).map((project, index) => (
          <ProjectCard
            key={index}
            title={project.title}
            content={project.content}
            url={project.url}
          />
        ))}
      </div>
    </Section>
  );
};

const pcStyles = {
  section: {
    ...globalStyles.fullHeightSection,
    ...globalStyles.darkBackground,
    paddingTop: "8vh",
    paddingBottom: "8vh",
    paddingLeft: "4vw",
    paddingRight: "4vw",
  },
  title: {
    ...globalStyles.textTitleSize,
    ...globalStyles.textLightGreyColor,
    ...globalStyles.titleSpacing,
    textAlign: "center",
    margin: "2rem",
  },
  projectCardContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "space-between",
    justifyContent: "center",
  },
};

const mobileStyles = {
  section: {
    ...globalStyles.fullHeightSection,
    ...globalStyles.darkBackground,
    display: "flex",
    alignItems: "center",
    paddingTop: "4rem",
    paddingBottom: "4rem",
  },
  title: {
    ...globalStyles.textSmallSize,
    ...globalStyles.textLightGreyColor,
    ...globalStyles.titleSpacing,
    textAlign: "center",
    margin: "2rem",
  },
};

ProjectsSection.propTypes = {
  anchorRef: PropTypes.shape().isRequired,
};

export default ProjectsSection;
